import * as actionTypes from './actionTypes';

export const setBrandProfileId = brandProfileId => (
  {
    type: actionTypes.SET_BRAND_PROFILE_ID,
    brandProfileId
  }
);

export const fetchStories = (brandProfileId, fromId) => (
  {
    type: actionTypes.FETCH_STORIES,
    brandProfileId,
    fromId
  }
);

export const setStories = stories => (
  {
    type: actionTypes.SET_STORIES,
    stories
  }
);

export const fetchEligibleUsers = brandProfileId => (
  {
    type: actionTypes.FETCH_ELIGIBLE_USERS,
    brandProfileId
  }
);

export const setEligibleUsers = users => (
  {
    type: actionTypes.SET_ELIGIBLE_USERS,
    users
  }
);

export const toggleConfirmModal = () => (
  {
    type: actionTypes.TOGGLE_CONFIRM_MODAL
  }
);

export const startReassignmentJob = (brandProfileId, fromUser, toUser) => (
  {
    type: actionTypes.START_REASSIGNMENT_JOB,
    brandProfileId,
    fromUser,
    toUser
  }
);

export const handlePollingJobStatus = (jobId, brandProfileId, fromId) => (
  {
    type: actionTypes.HANDLE_POLLING_JOB_STATUS,
    jobId,
    brandProfileId,
    fromId
  }
);

export const handleJobId = (jobId, brandProfileId, fromUser, toUser) => (
  {
    type: actionTypes.HANDLE_JOB_ID,
    jobId,
    brandProfileId,
    fromUser,
    toUser
  }
);

export const setJobId = jobId => (
  {
    type: actionTypes.SET_JOB_ID,
    jobId
  }
);

export const setJobStatus = jobStatus => (
  {
    type: actionTypes.SET_JOB_STATUS,
    jobStatus
  }
);

export const setPersistedJobStatus = (jobId, fromUser, toUser) => (
  {
    type: actionTypes.SET_PERSISTED_JOB_STATUS,
    jobId,
    fromUser,
    toUser
  }
);

export const handleJobRestart = (jobId, brandProfileId, fromUser, toUser) => (
  {
    type: actionTypes.HANDLE_JOB_RESTART,
    jobId,
    brandProfileId,
    fromUser,
    toUser
  }
);

export const removePersistedJobStatus = () => (
  {
    type: actionTypes.REMOVE_PERSISTED_JOB_STATUS
  }
);



// WEBPACK FOOTER //
// ./app/javascript/app/store/actions/reassignUsers.js